module.exports = __webpack_public_path__ + "img/w3_store_dark.880ca37a.png";